<template>
  <AppHeader>Sample Slots</AppHeader>

  <Loading v-if="state === 'loading'" />

  <div v-if="state === 'idle'" class="p-4">
    <div v-if="data.length !== 0" class="responsive-table">
      <table>
        <thead>
          <tr>
            <th>No</th>
            <th>Date</th>
            <th>Count</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(entry, index) in data" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ toDate(entry.date) }}</td>
            <td>
              <div v-for="(qty, name) in entry.products" :key="name">
                <span class="text-sm">{{ name }} : </span> <span class="text-xl">{{ qty }}</span>
              </div>
            </td>
            <td>{{ getTotal(entry.products) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="text-center text-gray-500">No data found</div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js'
import AppHeader from '@/components/common/Header.vue'
import Loading from '@/components/common/Loading.vue'

export default {
  name: 'ReportDealerSampleSlot',
  mixins: [mixin],
  components: { AppHeader, Loading },

  data() {
    return {
      state: 'idle',
      data: [],
    }
  },

  mounted() {
    this.getData()
  },

  methods: {
    getData() {
      this.state = 'loading'

      this.request('GET', 'reports/sample-slots', {}, (resp) => {
        this.state = 'idle';
        if (resp.success)this.data = resp.data.sample_slot_summary;
        else alert(resp.message);
      });
    },

    getTotal(products) {
      return Object.values(products).reduce((sum, qty) => sum + qty, 0)
    },
  },
}
</script>
